import { getBrandDisplayName, getMetaTags, getTheme } from "app/reducers/partnerSelector";
import { getUITheme } from "app/reducers/themeSelector";
import { useSelector, shallowEqual } from "react-redux";
import DefaultHeadMetadata from "app/utils/metas/DefaultHeadMetadata";
import { getSeoMetaData } from "app/reducers/partnerSelector";

const mapStateToProps = state => {
	return {
		brandDisplayName: getBrandDisplayName(state),
		theme: getUITheme(state),
		sanityTheme: getTheme(state),
		googleSiteVerificationId: state.partner.googleSiteVerificationId,
		metaTags: getMetaTags(state),
		titleFromSanity: getSeoMetaData("default.metaTitle")(state),
		descriptionFromSanity: getSeoMetaData("default.metaDescription")(state),
	};
};

const DefaultHeadMetadataContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <DefaultHeadMetadata {...props} {...stateProps} />;
};

export default DefaultHeadMetadataContainer;
